import ContractSummaryWidget from './ContractSummaryWidget';

export default ContractSummaryWidget;
